import { render, staticRenderFns } from "./BottomBar.vue?vue&type=template&id=6ccc4367&scoped=true"
import script from "./BottomBar.vue?vue&type=script&lang=js"
export * from "./BottomBar.vue?vue&type=script&lang=js"
import style0 from "./BottomBar.vue?vue&type=style&index=0&id=6ccc4367&prod&scoped=true&lang=css"
import style1 from "./BottomBar.vue?vue&type=style&index=1&id=6ccc4367&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ccc4367",
  null
  
)

export default component.exports